import type { IActiveSessionRepository } from '@/domain/repositories/IActiveSessionRepository';
import type { ActiveSessionSnapshot } from '@/domain/entities/ActiveSessionSnapshot';
import {
  ACTIVE_SESSION_KEY,
  ACTIVE_SESSION_STORE,
  openActivationRuntimeDb,
  promisifyRequest,
} from '@/infrastructure/indexeddb/activationRuntimeDb';

/** Implementação de `IActiveSessionRepository` sobre a object store
 * `activeSession` do IndexedDB (chave fixa única, fora do registro) — ADR-003,
 * Adendo 2026-07-25 (Correção 2). */
export class IndexedDbActiveSessionRepository implements IActiveSessionRepository {
  async get(): Promise<ActiveSessionSnapshot | null> {
    const db = await openActivationRuntimeDb();
    try {
      const tx = db.transaction(ACTIVE_SESSION_STORE, 'readonly');
      const result = await promisifyRequest<ActiveSessionSnapshot | undefined>(
        tx.objectStore(ACTIVE_SESSION_STORE).get(ACTIVE_SESSION_KEY)
      );
      return result ?? null;
    } finally {
      db.close();
    }
  }

  async save(snapshot: ActiveSessionSnapshot): Promise<void> {
    const db = await openActivationRuntimeDb();
    try {
      const tx = db.transaction(ACTIVE_SESSION_STORE, 'readwrite');
      await promisifyRequest(tx.objectStore(ACTIVE_SESSION_STORE).put(snapshot, ACTIVE_SESSION_KEY));
    } finally {
      db.close();
    }
  }

  async clear(): Promise<void> {
    const db = await openActivationRuntimeDb();
    try {
      const tx = db.transaction(ACTIVE_SESSION_STORE, 'readwrite');
      await promisifyRequest(tx.objectStore(ACTIVE_SESSION_STORE).delete(ACTIVE_SESSION_KEY));
    } finally {
      db.close();
    }
  }
}
